// store.js
import {
  configureStore,
  combineReducers,
  getDefaultMiddleware,
} from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

import authReducer from "./auth/authReducer";
import entities from "./entities/entitiesReducer";
import settings from "./settings/settingReducer";
import ui from "./ui/uiReducer";

const persistConfig = {
  timeout: 1000,
  key: "root",
  storage,
  blacklist: ["auth", "entities", "ui"],
};

const combinedReducers = combineReducers({
  entities,
  auth: authReducer,
  settings,
  ui,
});

const persistedReducer = persistReducer(persistConfig, combinedReducers);

const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: ["persist/PERSIST"],
    },
  }),
});

const persistor = persistStore(store);

export { store, persistor };
